// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--eKw+G";
export var main = "Layout-module--main--edh5p";